var path = '/account/sidepanel/systematicPlans/components/systematicPlansError.tpl.html';
var html = "<div ng-if=isLoaded class=subsection> <div class=space /> <dt class=dt-vertical-key></dt> <dd class=\"dt-vertical-value dt-vert-key ifds-red-text\" data-ng-bind=\"::getLabel({fieldName: 'payTypeMsgX'})\"> </dd></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/account/sidepanel/systematicPlans/components/systematicPlansError.tpl.html
// module id = 705
// module chunks = 0 2